import { showToast } from '../../components/Toast';
import {
  addBattlefieldSuccess,
  addBattlefieldFail,
  deleteBattlefieldSuccess,
  deleteBattlefieldFail,
  updateBattlefieldSuccess,
  updateBattlefieldFail,
  updatePeriodSuccess,
  updatePeriodFail,
  showLoading,
  hideLoading,
} from '../../store/battlefield/actions';
import { WsEvents } from '../events';
import { socket } from '../socket';

export function onAddBattlefield({ dispatch, order }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.battlefield.ADD, order, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(addBattlefieldFail(res));
      return;
    }
    showToast('New Battlefield Order is added');
    dispatch(addBattlefieldSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onUpdateBattlefield({ dispatch, order }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.battlefield.UPDATE, order, callback);

  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(updateBattlefieldFail(res));
      return;
    }
    showToast('Changes Successfully Applied');
    dispatch(updateBattlefieldSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onDeleteBattlefield({ dispatch, battleFieldIds }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.battlefield.DELETE, battleFieldIds, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(deleteBattlefieldFail(res));
      return;
    }
    let msg = 'Battle Field is deleted from the system';
    if (battleFieldIds.length > 1) {
      msg = 'Battle Fields are deleted from the system';
    }
    showToast(msg);
    dispatch(deleteBattlefieldSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onUpdateBattlefieldPeriod({ dispatch, battlefield }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.battlefield.UPDATE_PERIOD, battlefield, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(updatePeriodFail(res));
      return;
    }
    if (battlefield.period === 'start') {
      showToast('New Range Period is Set');
    } else if (battlefield.period === 'finish') {
      showToast('Month is finished');
    }
    showToast('Changes Successfully Applied');
    dispatch(updatePeriodSuccess(res));
    dispatch(hideLoading(false));
  }
}
